import styled from 'styled-components';

export const ModalTitle = styled.strong`
  width: 100%;
  text-align: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #888888;
  color: #f00;
`;

export const ModalText = styled.p`
  text-align: center;
`;
